<div *ngIf="showWidget || isLoading">
  <!-- Loading skeleton -->
  <div *ngIf="isLoading" class="meeting-hub-widget">
    <h3 class="widget-title">Meeting Hub</h3>
    <div class="widget-loading">
      <div class="skeleton-text skeleton-meeting-name"></div>
      <div class="skeleton-text skeleton-date"></div>
      <div class="skeleton-text skeleton-time"></div>
      <div class="skeleton-text skeleton-location"></div>
    </div>
  </div>

  <!-- Has upcoming meeting -->
  <div
    *ngIf="!isLoading && showWidget && nextMeeting"
    class="meeting-hub-widget"
  >
    <div class="widget-header">
      <h3 class="widget-title">Meeting Hub</h3>
      <span *ngIf="nextMeeting.accessType === 'Open'" class="upcoming-badge">
        <app-icon name="meeting-hub-clock" size="14px"></app-icon>
        {{ getBadgeText() }}
      </span>
      <span
        *ngIf="nextMeeting.accessType === 'Closed'"
        class="upcoming-badge upcoming-badge--board"
        tabindex="0"
        aria-describedby="board-access-tooltip"
      >
        Board Access Only
        <span id="board-access-tooltip" class="board-tooltip" role="tooltip">
          Board-only session — restricted to board members.
        </span>
      </span>
    </div>

    <div class="meeting-details">
      <div class="meeting-name">
        <app-icon name="meeting-hub-cal-icon" size="20px"></app-icon>
        {{ nextMeeting.meetingName }}
      </div>
      <div class="meeting-date">{{ getFormattedDate() }}</div>
      <div class="meeting-time">{{ getFormattedTime() }}</div>

      <div *ngIf="getLocationName()" class="meeting-location">
        <div
          class="location-name"
          [class.location-name--plain]="!isOpenMeeting()"
        >
          {{ getLocationName() }}
        </div>
        <div *ngIf="getLocationAddress()" class="location-address">
          {{ getLocationAddress() }}
        </div>
        <div *ngIf="getLocationCityStateZip()" class="location-address">
          {{ getLocationCityStateZip() }}
        </div>
      </div>

      <button
        *ngIf="showJoinMeetingLink()"
        class="join-meeting-btn"
        (click)="onJoinMeeting()"
        type="button"
      >
        Join Zoom Meeting
      </button>
    </div>

    <a
      class="widget-link"
      (click)="onGoToMeetingHub()"
      (keydown.enter)="onGoToMeetingHub()"
      tabindex="0"
      role="button"
    >
      Go to Meeting Hub
    </a>
  </div>

  <!-- No token yet — user hasn't visited Meeting Hub -->
  <div *ngIf="!isLoading && showWidget && !hasToken">
    <div class="meeting-hub-widget">
      <h3 class="widget-title">Meeting Hub</h3>
      <p class="no-meetings-message">
        View and manage your community meetings in the Meeting Hub
      </p>
      <a
        class="widget-link"
        (click)="onGoToMeetingHub()"
        (keydown.enter)="onGoToMeetingHub()"
        tabindex="0"
        role="button"
      >
        Go to Meeting Hub
      </a>
    </div>
  </div>

  <!-- Has token but no upcoming meetings -->
  <div *ngIf="!isLoading && showWidget && hasToken && !nextMeeting">
    <div class="meeting-hub-widget">
      <h3 class="widget-title">Meeting Hub</h3>
      <p class="no-meetings-message">
        There are no upcoming meetings but you may view past meetings in the
        Meeting Hub
      </p>
      <a
        class="widget-link"
        (click)="onGoToMeetingHub()"
        (keydown.enter)="onGoToMeetingHub()"
        tabindex="0"
        role="button"
      >
        Go to Meeting Hub
      </a>
    </div>
  </div>
</div>
